import { isAfter, isSameMinute, parseISO } from "date-fns";
import { z } from "zod";

import { DRIVER_PRICE_MAX_PERCENT_THRESHOLD } from "@/utils/delivery-pricing";

import errorMessages from "../error-messages";

function disablePast(date: string | Date | any) {
  const currentDate = new Date();
  const dateToCheck = date instanceof Date ? date : parseISO(date.toString());
  return isAfter(dateToCheck, currentDate) || isSameMinute(dateToCheck, currentDate);
}

const publishDeliverySchema = z
  .object({
    id: z.number(),
    clientFinalPrice: z.coerce.number().min(0.01, "Client price must be greater than 0"),
    carAvailabilityDate: z.coerce.date().refine((value) => disablePast(value), {
      message: errorMessages.disablePast,
    }),
    carPickUpDate: z.coerce.date().refine((value) => disablePast(value), {
      message: errorMessages.disablePast,
    }),
    carDeliveryDeadline: z.coerce.date().refine((value) => disablePast(value), {
      message: errorMessages.disablePast,
    }),
    selectedDriverId: z.coerce.number().nullish(),
    wantedPrice: z.number(),
    maxPrice: z.number().min(0.01, "Maximum price must be greater than 0"),
    minPrice: z.number(),
    medianPrice: z.number().optional(),
  })
  .refine(
    (data) =>
      data.clientFinalPrice <= 0 ||
      data.maxPrice <= data.clientFinalPrice * DRIVER_PRICE_MAX_PERCENT_THRESHOLD,
    {
      message: errorMessages.driverMaxExceedsClientPercent,
      path: ["maxPrice"],
    }
  );

export type PublishDeliverySchemaType = z.infer<typeof publishDeliverySchema>;
export default publishDeliverySchema;
